import api from '../config/axiosConfig';

export const SeguimientoService = {
    getValidaciones: async ({ token, vid }) => {
        try {
            const response = await api.get('/seguimiento/validaciones', {
                headers: { Authorization: `Bearer ${token}` },
                params: { vid },
            });
            return response.data;
        } catch (error) {
            console.error('Error en SeguimientoService.get:', error);
            throw error;
        }
    },
    createValidaciones: async ({ token, formData }) => {
        try {
            const response = await api.post('/seguimiento/validaciones', formData, {
                headers: { Authorization: `Bearer ${token}` },
            });
            return response.data;
        } catch (error) {
            console.error('Error en SeguimientoService.registrarPostulante:', error);
            throw error;
        }
    },
    disable: async ({ token, formData }) => {
        await api.put('/seguimiento/validaciones', formData, {
            headers: { Authorization: `Bearer ${token}` },
        });
    }
};
